<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt FhInt" id="HlicitacionesInt">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dSeis dtOcho dmOnce">
                    <h1>OFERTAS DE LICITACIÓN</h1>
                    <p class="mt-3">
						Queremos conocerte más, te invitamos a continuar con tu registro.
                    </p>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
	</div>

    <div class="FformContacto dDiez dtDiez dmOnce mt-5">

        <h3 class="text-center mb-3">¡REGÍSTRATE AQUÍ!</h3>

		<div class="row">
			<div class="col-12 mt-3">
                <!-- <form #f="ngForm" (ngSubmit)="onSubmit(f)" ngNativeValidate class="pb-3 row"> -->
                <form #f="ngForm" (ngSubmit)="onSubmit(f)" ngNativeValidate  class="pb-3 row">
                    <div class="row" style="width: 100%;">
                        <div class="form-group col-lg-4 col-md-6 text-left">
                            <label for="rfcescrito">RFC</label>
                            <input ngModel name="rfcescrito" type="text" class="form-control" id="rfcescrito" pattern="^[a-zA-Z]{3,4}[0-9]{6}[A-Za-z0-9]{2,3}" minlength="12" maxlength="13" required>
                        </div>
                        <div class="form-group col-lg-4 col-md-6 text-left">
                            <label for="password">Contraseña</label>
                            <div class="input-group">
                                <input ngModel name="password" class="form-control flat" id="password" [type]="fieldTextType ? 'text' : 'password'" placeholder="Contraseña" minlength="8" maxlength="12" required>
								<div class="input-group-prepend">
									<span class="input-group-text">
										<div class="iconoForm" [ngClass]="{
											'icono-eyeNo': !fieldTextType,
											'icono-eye': fieldTextType
											}" (click)="toggleFieldTextType()">
										</div>
									</span>
								</div>
                            </div>
                        </div>
                        <!-- <div class="form-group col-lg-4 col-md-6 text-left">
                            <label for="password">Confirmar contraseña</label>
                            <div class="input-group">
                                <input ngModel name="password" class="form-control flat" id="passwordvalid" [type]="fieldTextType ? 'text' : 'password'" placeholder="Contraseña" minlength="8" maxlength="12" required>
								<div class="input-group-prepend">
									<span class="input-group-text">
										<div class="iconoForm" [ngClass]="{
											'icono-eyeNo': !fieldTextType,
											'icono-eye': fieldTextType
											}" (click)="toggleFieldTextType()">
										</div>
									</span>
								</div>
                            </div>
                        </div> -->
                        <div class="form-group col-lg-4 col-md-6 text-left">
                            <label for="razonSocial">Razón social</label>
                            <input ngModel name="razonSocial" type="text" class="form-control" id="razonSocial" maxlength="60" required>
                        </div>
                        <div class="form-group col-lg-4 col-md-6  text-left">
                            <label for="calle">Calle</label>
                            <input ngModel name="calle" type="text" class="form-control" id="calle" maxlength="50" required>
                        </div>
                        <div class="form-group col-lg-4  col-6 text-left">
                            <label for="nInterior">N. Interior</label>
                            <input ngModel name="nInterior" type="text" class="form-control" id="nInterior" maxlength="20" value="S/N">
                        </div>
                        <div class="form-group col-lg-4  col-6 text-left">
                            <label for="nExterior">N. Exterior</label>
                            <input ngModel name="nExterior" type="text" class="form-control" id="nExterior" maxlength="20" required>
                        </div>
                        <div class="form-group col-lg-6 col-md-6 text-left">
                            <label for="colonia">Colonia</label>
                            <input ngModel name="colonia" type="text" class="form-control" id="colonia" maxlength="50" required>
                        </div>
                        <div class="form-group col-lg-6 col-md-6 text-left">
                            <label for="referencia">Referencia</label>
                            <input ngModel name="referencia" type="text" class="form-control" id="referencia" maxlength="100" required>
                        </div>
                        <div class="form-group col-lg-4 col-md-6 text-left">
                            <label for="estadoId">Estado</label>
                            <select ngModel name="estadoId" class="form-control" (ngModelChange)="getCiudades($event)" required>
                                <option [ngValue]="" selected>Seleccione Estado</option>
                                <option *ngFor="let estado of estados" [ngValue]="estado.idestado"> {{ estado.nombre | uppercase}} </option>
                            </select>
                        </div>
                        <div class="form-group col-lg-4 col-md-6 text-left">
                            <label for="ciudadId">Municipio</label>
                            <select ngModel name="ciudadId" class="form-control" required>
                                <option [ngValue]="" selected>Seleccione una Municipio o Alcaldía</option>
                                <option *ngFor="let ciudad of ciudades" [ngValue]="ciudad.idMunicipio"> {{ ciudad.nombre | uppercase}} </option>
                            </select>
                        </div>
                        <div class="form-group col-lg-4 col-md-6 text-left">
                            <label for="cp">Código Postal</label>
                            <input ngModel name="cp" type="text" class="form-control" id="cp" pattern="[0-9]{5,6}" required>
                        </div>
                        <div class="form-group col-lg-4 col-md-6 text-left">
                            <label for="giro">Giro de la empresa</label>
                            <input ngModel name="giro" type="text" class="form-control" id="giro" maxlength="50" required>
                        </div>
    
                        <div class="form-group col-lg-4 col-md-6 text-left">
                            <label for="nombreContacto">Nombre del contacto</label>
                            <input ngModel name="nombreContacto" type="text" class="form-control" id="nombreContacto" maxlength="50" required>
                        </div>
                        <div class="form-group col-lg-4 col-md-6 text-left">
                            <label for="apellidoPaterno">Apellido paterno</label>
                            <input ngModel name="apellidoPaterno" type="text" class="form-control" id="apellidoPaterno" maxlength="50" required>
                        </div>
                        <div class="form-group col-lg-4 col-md-6 text-left">
                            <label for="apellidoMaterno">Apellido materno</label>
                            <input ngModel name="apellidoMaterno" type="text" class="form-control" id="apellidoMaterno" maxlength="50" required>
                        </div>
                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="telefonoFijo">Teléfono fijo</label>
                            <input ngModel name="telefonoFijo" type="tel" class="form-control" id="telefonoFijo" pattern="[0-9]{10}" maxlength="15" required>
                        </div>
                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="telefonoMovil">Teléfono móvil</label>
                            <input ngModel name="telefonoMovil" type="tel" class="form-control" id="telefonoMovil" pattern="[0-9]{10}" maxlength="15" required>
                        </div>
                        <div class="form-group col-lg-8 text-left">
                            <label for="email">Correo electrónico</label>
                            <input ngModel name="email" type="email" maxlength="50" class="form-control" id="email" required>
                        </div>
                    </div>

                    <div class="row upload pb-1" style="width: 100%;">
                        <div class="form-group col-lg-4 col-md-6">
                            <label for="cvEmpresarial">CV empresarial</label>
                            <input type="file" accept="application/pdf" (change)="cvEmpresarialInput($event)"
                                class="form-control-file" id="cvEmpresarial" required>
                        </div>
                        <div class="form-group col-lg-4 col-md-6">
                            <label for="domicilioFiscal">Comprobante de domicilio fiscal</label>
                            <input type="file" accept="application/pdf" (change)="domicilioFiscalInput($event)"
                                class="form-control-file" id="domicilioFiscal" required>
                        </div>
                        <div class="form-group col-lg-4 col-md-6">
                            <label for="situacionFiscal">Comprobante de situación fiscal</label>
                            <input type="file" accept="application/pdf" (change)="situacionFiscalInput($event)"
                                class="form-control-file" id="situacionFiscal" required>
                        </div>
                        <div class="form-group col-lg-4 col-md-6">
                            <label for="estadoCuenta">Estado de cuenta</label>
                            <input type="file" accept="application/pdf" (change)="estadoCuentaInput($event)"
                                class="form-control-file" id="estadoCuenta" required>
                        </div>
                        <div class="form-group col-lg-4 col-md-6">
                            <label for="rfc">RFC</label>
                            <input type="file" accept="application/pdf" (change)="rfcInput($event)"
                                class="form-control-file" id="rfc" required>
                        </div>
    
                        <div class="form-group col-lg-4 col-md-6">
                            <label for="ine">INE (Representante legal)</label>
                            <input type="file" accept="application/pdf" (change)="ineInput($event)"
                                class="form-control-file" id="ine" required>
                        </div>
    
                        <div class="form-group col-lg-4 col-md-6">
                            <label for="imss">Evaluación del IMSS</label>
                            <input type="file" accept="application/pdf" (change)="imssInput($event)"
                                class="form-control-file" id="imss" required>

                        </div>
    
                        <div class="form-group col-lg-4 col-md-6">
                            <label for="foto">Foto de la fachada de la empresa</label>
                            <input type="file" accept="image/png, image/jpeg" (change)="fotoInput($event)"
                                class="form-control-file" id="foto" required>
                        </div>

                        <div class="form-group col-lg-4 col-md-6">
                            <label for="ocumpli">Opinión de Cumplimiento</label>
                            <input type="file" accept="application/pdf" (change)="oCumplimientoInput($event)"
                                class="form-control-file" id="ocumpli" required>
                        </div>

                        
                    </div>
                    <div class="form-check pt-1 pb-3 col-12 ml-3 text-left">
                        <input type="checkbox" id="deacuerdo" class="form-check-input" required>
                        <label id="deacuerdoLabel" for="deacuerdo" class="form-check-label">&nbsp;&nbsp;Estoy de acuerdo con el <a [routerLink]="['/aviso-de-privacidad']" target="_blank" rel="noopener">Aviso de privacidad</a></label>
                    </div>
                    <button type="submit" class="btn-enviar px-5">Enviar</button>
                </form>
                <div class="alerta-exito text-center" *ngIf="this.success">
                    <img class="ico-confirmar" src="./../../../../assets/images/icons/icono-exito.png">
                    <p>Su <strong>registro</strong> ha sido completado <strong>exitosamente.</strong></p>
                    <button class="btn-confirmar" (click)="closeok()">Aceptar</button>
                </div>
                <div class="col-12 alerta-error text-center" *ngIf="this.error">
                    <img class="icono-error" src="./../../../../assets/images/icons/icono-error.png">
                    <!--<p>{{errormsj}}</p>-->
                    <button class="btn-cancelar" (click)="closeok()">Aceptar</button>
                </div>

			</div>
		</div>
	</div>

</div>